<template>
    <kt-row>
        <kt-col xs="12">
            <form id="card_to_card_wage_settings_form">
                <div class="container p-3 pt-5 my-4 border in-border-header">
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('label.wage_settings') }}
                        </div>
                        <kt-form-group>
                            <kt-form-label>
                                {{ $t('label.change_wage_type') }}
                            </kt-form-label>
                            <kt-form-select size="3" id="wage_type" name="wage_type" v-model="form_data.wage_type">
                                <option
                                    v-bind:key="index"
                                    v-for="(wage_type, index) in wage_types"
                                    v-bind:value="wage_type.value"
                                    :selected="wage_type.value"
                                >
                                    {{ wage_type.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>

                        <transition name="fade">
                            <kt-form-group v-if="form_data.wage_type == 1">
                                <kt-form-label>
                                    {{ $t('label.change_wage_period') }}
                                </kt-form-label>
                                <kt-form-select
                                    size="4"
                                    id="wage_periodic_type"
                                    name="wage_periodic_type"
                                    v-model="form_data.wage_periodic_type"
                                >
                                    <option
                                        v-bind:key="index"
                                        v-for="(wage_periodic_type, index) in wage_periodic_types"
                                        v-bind:value="wage_periodic_type.value"
                                        :selected="wage_periodic_type.value"
                                    >
                                        {{ wage_periodic_type.name }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group>
                                <kt-form-label>
                                    {{
                                        (form_data.wage_type == 3) ?
                                            $t('label.wage_amount_percent') :
                                            ((form_data.wage_type == 2) ?
                                                $t('label.wage_amount_fixed') :
                                                $t('label.wage_amount_periodic'))
                                    }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="wage_amount" name="wage_amount"
                                                     v-model="form_data.wage_amount">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 3px">{{
                                    (form_data.wage_type == 3) ?
                                        $t('label.percent') :
                                        $t('currency.rial')
                                }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group v-if="form_data.wage_type == 3">
                                <kt-form-label>
                                    {{ $t('label.min_wage_amount') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="wage_min_wage" name="wage_min_wage"
                                                     v-model="form_data.wage_min_wage">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 2px">{{ $t('currency.rial') }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group v-if="form_data.wage_type == 3">
                                <kt-form-label>
                                    {{ $t('label.max_wage_amount') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="wage_max_wage" name="wage_max_wage"
                                                     v-model="form_data.wage_max_wage">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 2px">{{ $t('currency.rial') }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group>
                                <div class="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="need_monthly_recharge"
                                        name="need_monthly_recharge"
                                        v-model="form_data.need_monthly_recharge"
                                    >
                                    <label class="custom-control-label" for="need_monthly_recharge">{{
                                            $t('card_to_card.need_monthly_recharge')
                                        }}</label>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade" v-if="form_data.need_monthly_recharge">
                            <kt-form-group>
                                <kt-form-label for="credit_date">
                                    {{ $t('card_to_card.credit_date') }}
                                </kt-form-label>
                                <kt-form-control
                                    id="credit_date"
                                    name="credit_date"
                                    disabled
                                    :value="form_data.credit_date"
                                    dir="ltr"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </transition>
                        <transition name="fade" v-if="form_data.need_monthly_recharge">
                            <kt-form-group>
                                <kt-form-label for="monthly_credit_price">
                                    {{ $t('card_to_card.monthly_credit_price') }}
                                </kt-form-label>
                                <kt-form-control
                                    id="monthly_credit_price"
                                    name="monthly_credit_price"
                                    type="number"
                                    v-model="form_data.monthly_credit_price"
                                    dir="ltr"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </transition>
                    </kt-form-section>
                    <kt-form-action style="text-align: end">
                        <button class="btn btn-md btn-success" type="button"
                                @click="edit"
                                id="card_to_card_change_wage_btn">
                            {{ $t('btn.edit') }}
                        </button>
                    </kt-form-action>
                </div>
            </form>
        </kt-col>
    </kt-row>
</template>

<script>
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {KTUtil} from '@/plugins/core/util';
import {depositStatus, depositStatusStr} from '@/constants/deposit'
import {mapGetters} from 'vuex'
import {cardToCardService} from '@/common/api.service'
import {i18n} from '@/plugins/i18n'

export default {
    computed: {
        ...mapGetters('cardToCard', [
            'form_data'
        ])
    },
    mounted() {
        this.runSelectPicker()
    },
    data() {
        return {
            depositStatus,
            depositStatusStr,
            wage_types: [
                {
                    name: this.$t('gateway.wage_types.percent'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 2
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 1,
                }
            ],
            wage_periodic_types: [
                {
                    name: this.$t('gateway.wage_periodic_types.1'),
                    value: 1
                },
                {
                    name: this.$t('gateway.wage_periodic_types.3'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_periodic_types.6'),
                    value: 6,
                },
                {
                    name: this.$t('gateway.wage_periodic_types.12'),
                    value: 12,
                }
            ]
        }
    },
    methods: {
        edit() {
            let btn = $('#card_to_card_change_wage_btn')
            let form = $('#card_to_card_wage_settings_form')

            form.validate({
                rules: {
                    wage_type: {
                        required: true
                    },
                    wage_amount: {
                        required: true,
                    },
                    wage_periodic_type: {
                        required: this.form_data.wage_type == 1
                    },
                    wage_min_wage: {
                        required: this.form_data.wage_type == 3,
                    },
                    wage_max_wage: {
                        required: this.form_data.wage_type == 3,
                    },
                    monthly_credit_price: {
                        required: this.form_data.need_monthly_recharge,
                        digits : true
                    },
                }
            });

            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)

            cardToCardService.adminUpdateWage(this.form_data.id, {
                wage_type: this.form_data.wage_type,
                wage_periodic_type: this.form_data.wage_periodic_type,
                wage_amount: this.form_data.wage_amount,
                wage_min_wage: Number(this.form_data.wage_min_wage),
                wage_max_wage: this.form_data.wage_max_wage,
                need_monthly_recharge: this.form_data.need_monthly_recharge,
                monthly_credit_price: this.form_data.need_monthly_recharge ? this.form_data.monthly_credit_price : 0,
            }).then(response => {
                this.showMsg(form, 'success', response.data.message);
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message);
            }).finally(response => {
                KTUtil.scrollTop();
                KTApp.unprogress(btn)
            })
        },
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>